module.exports = __webpack_public_path__ + "img/jiankong.68bd8a8c.png";